module.exports = __webpack_public_path__ + "static/img/li1_3.2c7ff984.png";